import React, { useEffect, useRef, useState } from 'react';
import { loadPhoto, finishPage } from './docScan';

const B = { padding: '13px 10px', border: '1px solid #35507a', borderRadius: 12, background: '#1a2d48', color: '#fff', fontSize: 16, fontWeight: 600, flex: 1, cursor: 'pointer' };
const GO = { ...B, background: '#f8703c', borderColor: '#f8703c' };
const nextFrame = () => new Promise((r) => { setTimeout(r, 30); });

// One page: the photo with four corners to drag onto the paper, then the black and white result to check before it's kept.
export default function DocScanner({ file, t, onDone, onCancel }) {
  const [photo, setPhoto] = useState(null);
  const [corners, setCorners] = useState(null);
  const [turns, setTurns] = useState(0);
  const [page, setPage] = useState(null);
  const [busy, setBusy] = useState(true);
  const [err, setErr] = useState('');
  const svg = useRef(null);
  const drag = useRef(null);
  useEffect(() => {
    let on = true;
    (async () => {
      await nextFrame();
      try { const p = await loadPhoto(file); if (on) { setPhoto(p); setCorners(p.corners); } } catch { if (on) setErr(t.scanBad); } finally { if (on) setBusy(false); }
    })();
    return () => { on = false; };
  }, [file, t]);
  const make = async (q) => {
    setBusy(true); await nextFrame();
    try { setTurns(q); setPage(finishPage(photo, corners, q)); } catch { setErr(t.scanBad); } finally { setBusy(false); }
  };
  const move = (e) => {
    if (drag.current == null || !svg.current) return;
    const r = svg.current.getBoundingClientRect(); const k = photo.w / r.width;
    const x = Math.max(0, Math.min(photo.w, (e.clientX - r.left) * k)); const y = Math.max(0, Math.min(photo.h, (e.clientY - r.top) * k));
    setCorners((c) => c.map((p, i) => (i === drag.current ? { x, y } : p)));
  };
  const dot = photo ? Math.max(photo.w, photo.h) / 34 : 0;
  return (
    <div role="dialog" aria-label={t.scanTitle} style={{ position: 'fixed', inset: 0, zIndex: 2000, display: 'flex', flexDirection: 'column', gap: 10, boxSizing: 'border-box', padding: 12, background: '#0b1626', color: '#fff' }}>
      <div style={{ fontSize: 16, textAlign: 'center' }}>{page ? t.scanCheck : photo ? (photo.found ? t.scanCorners : t.scanNoEdges) : t.scanWorking}</div>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {page && <img src={page.url} alt={t.scanTitle} style={{ maxWidth: '100%', maxHeight: '100%', background: '#fff' }} />}
        {!page && photo && corners && (
          <svg ref={svg} viewBox={`0 0 ${photo.w} ${photo.h}`} style={{ maxWidth: '100%', maxHeight: '100%', touchAction: 'none' }} onPointerMove={move} onPointerUp={() => { drag.current = null; }} onPointerCancel={() => { drag.current = null; }}>
            <image href={photo.url} width={photo.w} height={photo.h} />
            <polygon points={corners.map((p) => `${p.x},${p.y}`).join(' ')} fill="rgba(248,112,60,.14)" stroke="#f8703c" strokeWidth={dot / 5} />
            {corners.map((p, i) => (
              <g key={i} data-corner={i} style={{ cursor: 'grab' }} onPointerDown={(e) => { drag.current = i; if (svg.current.setPointerCapture) svg.current.setPointerCapture(e.pointerId); }}>
                <circle cx={p.x} cy={p.y} r={dot * 1.6} fill="transparent" />
                <circle cx={p.x} cy={p.y} r={dot * 0.6} fill="#fff" stroke="#f8703c" strokeWidth={dot / 4} />
              </g>
            ))}
          </svg>
        )}
      </div>
      {err && <div role="alert" style={{ textAlign: 'center', color: '#fca5a5' }}>{err}</div>}
      <div style={{ display: 'flex', gap: 8 }}>
        {page ? (
          <>
            <button type="button" style={B} disabled={busy} onClick={() => setPage(null)}>{t.scanBack}</button>
            <button type="button" style={B} disabled={busy} onClick={() => make(turns + 1)}>{t.scanTurn}</button>
            <button type="button" style={GO} disabled={busy} onClick={() => onDone(page)}>{t.scanUse}</button>
          </>
        ) : (
          <>
            <button type="button" style={B} onClick={onCancel}>{t.scanCancel}</button>
            <button type="button" style={GO} disabled={busy || !photo} onClick={() => make(turns)}>{busy ? t.scanWorking : t.scanNext}</button>
          </>
        )}
      </div>
    </div>
  );
}
